import React from 'react';
import { usePaymentProfile } from '../context/payment-profile';
import { EmailVerificationScreen } from './email-verification-screen';

/**
 * Gate de identidad por email (2026-07-31): si el perfil está COMPLETO pero el email
 * todavía no fue verificado, la app entera se reemplaza por la pantalla única
 * "Verificá tu email" — MVP deliberado: no se puede usar nada hasta confirmar el
 * código (el backend además rechaza crear entidades con 403 email_not_verified).
 *
 * Encadenado con el popup de datos esenciales (payment-data-gate): mientras el
 * perfil NO esté completo manda el popup (ahí se carga el email); completo y sin
 * verificar, manda esta pantalla; verificado, la app. Las rutas públicas legales
 * (/privacy, /terms, /data-deletion) no se bloquean. Si el perfil no se pudo cargar
 * (profile null), se deja pasar — mismo fail-open que el popup: el enforcement real
 * está en el backend.
 */
export const EmailVerificationGate: React.FC<React.PropsWithChildren<{ isPublic: boolean }>> =
  ({ isPublic, children }) => {
    const { profile, loading, complete } = usePaymentProfile();
    const needsVerification =
      !isPublic && !loading && !!profile && complete && !profile.email_verified;
    if (needsVerification) return <EmailVerificationScreen />;
    return <>{children}</>;
  };
